<template>
    <div class="nodata_box">
        <img src="../assets/nodata.jpg" alt="">
    </div>
</template>
<script>
   export default{
    data() {
       return {
        
       }
    },
    props: {
        
     },
   }
</script>
<style scoped lang="scss">
.nodata_box{
    width: 100%;
    display: flex;
    justify-content: center;
    align-content: center;
    
    img{
        width: 180px;
        margin-top: 120px;
        margin-bottom: 120px;
  
    }

}
@media only screen and (max-width: 767px) {
    .nodata_box{
 
    img{
        width: 120px;
        margin-top: 120px;
        margin-bottom: 120px;
  
    }

}  
}

</style>
